import React from 'react';
import HeaderFive from '../../components/Header/HeaderFive';
import LoginMain from './LoginMain';
import FooterThree from '../../components/Footer/FooterThree';

const Login = () => {
  return (
    <>
      <HeaderFive />

      <LoginMain />

      <FooterThree />
    </>
  );
};

export default Login;
